var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetFallBackLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.5,
    height: 16.5,
    viewBox: "0 0 90 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.144775 0L8.38543 8.45491C13.8737 2.07921 24.5783 2.92389 25.4848 2.92389V26.0714L37.648 38.5791V0H0.144775Z",
    fill: "#A8B0BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.414 0H43.9191V45.0523L56.074 57.56V2.92389C56.9887 2.92389 67.6851 2.1117 73.1981 8.45491H89.6299L81.414 0Z",
    fill: "#A8B0BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetFallBackLight);
export default __webpack_public_path__ + "static/media/AssetFallBackLight.df958bf4a624dbd791834bdd205b9341.svg";
export { ForwardRef as ReactComponent };